/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkerStatusDto } from './WorkerStatusDto';
import {
    WorkerStatusDtoFromJSON,
    WorkerStatusDtoFromJSONTyped,
    WorkerStatusDtoToJSON,
} from './WorkerStatusDto';

/**
 * 
 * @export
 * @interface WorkerWithStatusDto
 */
export interface WorkerWithStatusDto {
    /**
     * The ID of the worker.
     * @type {number}
     * @memberof WorkerWithStatusDto
     */
    id: number;
    /**
     * The endpoint of the worker.
     * @type {string}
     * @memberof WorkerWithStatusDto
     */
    endpoint: string;
    /**
     * Indicates if an API key has been configured. The key itself is never exposed.
     * @type {boolean}
     * @memberof WorkerWithStatusDto
     */
    hasApiKey: boolean;
    /**
     * 
     * @type {WorkerStatusDto}
     * @memberof WorkerWithStatusDto
     */
    status: WorkerStatusDto;
}

/**
 * Check if a given object implements the WorkerWithStatusDto interface.
 */
export function instanceOfWorkerWithStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "endpoint" in value;
    isInstance = isInstance && "hasApiKey" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function WorkerWithStatusDtoFromJSON(json: any): WorkerWithStatusDto {
    return WorkerWithStatusDtoFromJSONTyped(json, false);
}

export function WorkerWithStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkerWithStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'endpoint': json['endpoint'],
        'hasApiKey': json['hasApiKey'],
        'status': WorkerStatusDtoFromJSON(json['status']),
    };
}

export function WorkerWithStatusDtoToJSON(value?: WorkerWithStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'endpoint': value.endpoint,
        'hasApiKey': value.hasApiKey,
        'status': WorkerStatusDtoToJSON(value.status),
    };
}

